import { render, staticRenderFns } from "./outstanding-documents.vue?vue&type=template&id=40bae14b"
import script from "./outstanding-documents.vue?vue&type=script&lang=js"
export * from "./outstanding-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bae14b')) {
      api.createRecord('40bae14b', component.options)
    } else {
      api.reload('40bae14b', component.options)
    }
    module.hot.accept("./outstanding-documents.vue?vue&type=template&id=40bae14b", function () {
      api.rerender('40bae14b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/dashboard/components/outstanding-documents.vue"
export default component.exports